// extracted by mini-css-extract-plugin
export default {"List":"CartandFavsPage_List__NMnMt"};